.c-timeline__timeline {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 4rem
}
  .c-timeline__year {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}
  @media (max-width: 767px) {
    .c-timeline__year {
        font-size: 0.875rem;
        line-height: 1.25rem
    }
}
  .c-timeline__year {
    --tw-bg-opacity: 1;
    background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
    height: 4rem;
    width: 4rem
}
  @media (max-width: 767px) {
    .c-timeline__year {
        height: 3rem;
        width: 3rem
    }
}
  .c-timeline__year {
    border-radius: 9999px
}
  .c-timeline__item {
    display: grid;
    grid-auto-flow: column dense;
    grid-template-columns: repeat(2, minmax(0, 1fr))
}
  @media (max-width: 767px) {
    .c-timeline__item {
        font-size: 0.875rem;
        line-height: 1.25rem
    }
}
  .c-timeline__item div:first-child {
    display: flex;
    flex-direction: column
}
  .c-timeline__item div:last-child {
    display: flex
}
  .c-timeline__item .c-timeline__content {
    --tw-bg-opacity: 1;
    background-color: rgb(244 244 245 / var(--tw-bg-opacity, 1));
    border-radius: 0.5rem;
    border-width: 1px;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    padding: 0.5rem;
    font-weight: 600
}
  .c-timeline__item time {
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 500;
    --tw-text-opacity: 1;
    color: rgb(113 113 122 / var(--tw-text-opacity, 1))
}
  .c-timeline__item:nth-of-type(odd) > div:first-child {
    padding-right: 0.5rem;
    border-right-width: 2px;
    --tw-border-opacity: 1;
    border-color: rgb(59 130 246 / var(--tw-border-opacity, 1))
}
  .c-timeline__item:nth-of-type(even) > div:first-child {
    grid-column-start: 2;
    padding-left: 0.5rem
}
  .c-timeline__item:nth-of-type(even) > div:last-child {
    grid-column-start: 1;
    border-right-width: 2px;
    --tw-border-opacity: 1;
    border-color: rgb(59 130 246 / var(--tw-border-opacity, 1))
}

/*# sourceMappingURL=data:application/json;base64,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 */